import type { QueryClient } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import { authClient } from './client';
import { withWebRole } from './roles';

export const authQueryKey = ['auth', 'session'] as const;

export function useAuth() {
  return useQuery({
    queryKey: authQueryKey,
    queryFn: async () => {
      const session = await authClient.getSession();
      return withWebRole(session.data);
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: false,
  });
}

/** Get auth session from query cache, used by router beforeLoad */
export async function getAuthFromQueryClient(queryClient: QueryClient) {
  return queryClient.ensureQueryData({
    queryKey: authQueryKey,
    queryFn: async () => {
      const session = await authClient.getSession();
      return withWebRole(session.data);
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
